import { useEffect, useState } from "react";
import { Building2, User } from "lucide-react";
import { api } from "../../lib/api";
import Workspace from "./Workspace";

// Admin wrapper: choose between the shared founder workspace and any client's
// private workspace, then render the shared Workspace UI against the right scope.
export default function AdminWorkspace() {
  const [clients, setClients] = useState([]);
  const [selected, setSelected] = useState(""); // "" = admin's own workspace

  useEffect(() => {
    api.get("/admin/vault").then(({ data }) => setClients(data.vault || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-workspace">
      <div className="flex items-center gap-3 mb-5 flex-wrap">
        <div className="flex items-center gap-2 text-sm text-[#1e3d3a]/70">
          <User className="h-4 w-4 text-[#c9a961]" /> Viewing:
        </div>
        <select
          data-testid="admin-workspace-client"
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          className="rounded-lg border border-[#1e3d3a]/15 bg-white px-3 py-2 text-sm text-[#1e3d3a] focus:border-[#c9a961] focus:outline-none max-w-xs"
        >
          <option value="">My admin workspace</option>
          {clients.map((c) => (
            <option key={c.client_id} value={c.client_id}>
              {c.business_name ? `${c.business_name} — ` : ""}{c.client_id}
            </option>
          ))}
        </select>
        {selected && (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-[#c9a961]/12 px-3 py-1 text-[11px] font-medium text-[#8a6d2f]">
            <Building2 className="h-3 w-3" /> Client workspace
          </span>
        )}
      </div>
      <Workspace key={selected || "admin"} apiBase="/admin/workspace" clientEmail={selected || null} />
    </div>
  );
}
